export default __webpack_public_path__ + "static/media/failureImg.6c5d7ca8.png";